import React from 'react';
import {Checkbox, ListItemText, MenuItem, TextField} from '@mui/material';
import {dashboardMetrics} from './dashboardMetrics';
import {dashboardMetricInputStyles, dashboardMetricMenuProps} from './DashboardControls';

export default function ChartMetricSelect({value, onChange}) {
    const allSelected = value.length === dashboardMetrics.length;
    const handleChange = event => {
        const selected = event.target.value;
        onChange(selected.includes('all')
            ? allSelected ? [] : dashboardMetrics.map(metric => metric.key)
            : selected);
    };
    return (
        <TextField
            select size="small"
            label="Chart metrics"
            value={value}
            onChange={handleChange}
            slotProps={{
                select: {
                    multiple: true,
                    displayEmpty: true,
                    renderValue: selected => selected.length === dashboardMetrics.length ? 'All metrics'
                        : selected.length === 1 ? dashboardMetrics.find(metric => metric.key === selected[0]).label
                            : selected.length ? `${selected.length} metrics` : 'Select metrics',
                    MenuProps: dashboardMetricMenuProps
                },
                inputLabel: {shrink: true}
            }}
            sx={dashboardMetricInputStyles}
        >
            <MenuItem value="all" aria-selected={allSelected} divider>
                <Checkbox size="small" checked={allSelected} indeterminate={value.length > 0 && !allSelected}/>
                <ListItemText primary="Select all"/>
            </MenuItem>
            {dashboardMetrics.map(metric => (
                <MenuItem key={metric.key} value={metric.key}>
                    <Checkbox size="small" checked={value.includes(metric.key)}/>
                    <ListItemText primary={metric.label}/>
                </MenuItem>
            ))}
        </TextField>
    );
}
